import { Components, Theme } from '@mui/material/styles';

export const flowTableCell: Components<Theme>['MuiTableCell'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.disclaimer1,
      borderColor: 'inherit',
      padding: '4px 16px',
      height: '56px',
      // set min width for all cells except those including checkbox
      '&:not(.MuiTableCell-paddingCheckbox)': {
        minWidth: '150px',
        [theme.breakpoints.down('lg')]: {
          minWidth: '122px',
        },
      },
    }),
    head: ({ theme }) => ({
      ...theme.typography.caption2,
      position: 'relative',
      height: '54px',
      // not checkbox
      '&:not(.MuiTableCell-paddingCheckbox)': {
        // create offset (-8px)
        paddingLeft: '8px',
        paddingRight: '8px',
      },
      [theme.breakpoints.up('xs')]: {
        fontWeight: '700',
      },
      // show divider only for cells whose have some child
      '&:not(:empty)': {
        '&:after': {
          content: '""',
          position: 'absolute',
          left: '0',
          top: '50%',
          // manual v-align
          marginTop: '-12px',
          height: '24px',
          width: '1px',
          backgroundColor: theme.palette.surface.secondary,
        },
        // for right align switch divider position
        '&.MuiTableCell-alignRight': {
          '&:after': {
            left: 'initial',
            right: '0',
          },
        },
      },
      // hide divider for first cell if not right aligned
      '&:first-of-type': {
        '&:not(.MuiTableCell-alignRight):after': {
          display: 'none',
        },
      },
    }),
    // center checkbox
    paddingCheckbox: {
      padding: '0',
      textAlign: 'center',
      minWidth: '56px',
    },
  },
};
